import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useReferralLink } from "@features/Referral/useReferralLink";
import { Button } from "@components/Button/Button";
import { EuroIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useOverviewQuery } from "@services/overview/queries";
import { copyToClipboard } from "@utils/common";
import { sanitizeHtml } from "@utils/html";

export const ReferralTemplateModal: React.FC<IUseModalProps> = (props) => {
  const { t } = useTranslation();
  const modal = useModal(props);
  const { data: overview } = useOverviewQuery();
  const link = useReferralLink();
  const textareaRef = useRef<HTMLDivElement>(null);

  const copyLink = () => copyToClipboard(link, t("referral.toast.linkCopied"));

  const copyText = () =>
    copyToClipboard(
      textareaRef?.current?.innerText ?? "",
      t("referral.toast.textCopied"),
    );

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: EuroIcon }}
      actionButtons={
        <React.Fragment>
          <Button variant="secondary" className="w-full" onClick={copyLink}>
            {t("referral.templateModal.buttons.copyLink")}
          </Button>
          <Button className="w-full" onClick={copyText}>
            {t("referral.templateModal.buttons.copyText")}
          </Button>
        </React.Fragment>
      }
      title={t("referral.templateModal.title")}
      subtitle={t("referral.templateModal.subtitle")}
    >
      <div
        ref={textareaRef}
        className="h-80 w-full overflow-auto whitespace-pre-wrap rounded-xl border border-grey-hover px-4 py-2.5 outline-none transition-shadow focus:border-green-dark focus:ring-4 focus:ring-green-dark focus:ring-opacity-10"
        contentEditable={true}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            t("referral.templateModal.text", {
              link,
              name: overview?.firstName,
            }),
          ),
        }}
      />
    </Modal>
  );
};
